const isEvo = import.meta.env.EVO;

export class AdAPI {
  // SSO跳转
  public static openQQLive = (sso: string) => {
    if (isEvo && vnContext && vnContext.external) {
      vnContext.external.openQQLive(sso);
    }
  };

  // 打开落地页
  public static openLandingPageWnd = (
    title: string,
    leftPageUrl: string,
    rightPageUrl: string,
    info: string,
    rightPaneWidth: number
  ): void => {
    if (isEvo && vnContext && vnContext.external) {
      vnContext.external.openLandingPageWnd(
        title,
        leftPageUrl,
        rightPageUrl,
        info,
        rightPaneWidth
      );
    }
  };

  // 广告端内拉起落地页，无白名单校验
  public static openHintBrowser = (s: string): void => {
    if (isEvo && vnContext && vnContext.external) {
      vnContext.external.openHintBrowser(s);
    }
  };

  // 拉起浏览器
  public static navigateURL = (url: string): boolean => {
    if (isEvo && vnContext && vnContext.external) {
      vnContext.external.navigateURL(url);
      return true;
    }
    return false;
  };

  // 客户端的数据 需要对齐具体的 key
  public static setCommonInfo = (_key: string, _value: string): void => {};

  // TAB 配置
  public static getRemoteConfig = (
    key: string,
    defaultValue: string
  ): string => {
    if (isEvo && vnContext && vnContext.external) {
      return vnContext.external.getRemoteConfig(key, defaultValue);
    }

    return defaultValue;
  };

  // TAB 配置2，额外获得
  public static getRemoteConfig2 = (
    key: string,
    defaultValue: string
  ): [string, TabExperimentInfo] => {
    if (vnContext?.external?.getRemoteConfig2) {
      return vnContext.external.getRemoteConfig2(key, defaultValue);
    }

    return [defaultValue, { expId: 0, expName: "" }];
  };
}
